<app-loader [showLoader]="isLoading"></app-loader>

<div class="white-wrap-admin">
  <div class="back-link-outer d-flex row mb-2 mb-md-0">
    <div class="back-link-outer mb-0 mb-md-2 d-flex col-3 align-items-center">
      <a role="button" (click)="goToBack()" class="back-link">
        <img alt="back" src="../assets/images/back.svg" /> back
      </a>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12 col-md-7">
      <p class="body-txt-22 mb-3">Auction Details</p>
    </div>
    <div class="col-12 col-md-5 d-md-block">
      <div class="for-icons justify-content-end">
        <ng-container *ngIf="auctionDetail?.saleType?.isDetailPageInHouse">
          <ng-container *ngIf="!auctionDetail?.saleType?.isCatalogReadOnly">
            <button *ngIf="
                auctionDetail?.auctionStatus == auctionStatuses.live ||
                (auctionDetail?.auctionStatus == auctionStatuses.past &&
                  auctionDetail?.isBidAvailable)
              " type="button" routerLink="bids" class="btn btn-colored mr-2 btn-13">
              View Bids
            </button>
          </ng-container>
        </ng-container>

        <a class="hover-icon edit-icon mr-2" role="button" (click)="goToEdit()"></a>

        <div class="custom-dropdown" *ngIf="showMatMenu">
          <button *ngIf="auctionDetail?.saleType?.isDetailPageInHouse" class="no-bg-btn hover-icon" mat-icon-button
            [matMenuTriggerFor]="listingMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #listingMenu="matMenu">
            <div class="custom-dropdown">
              <ng-container *ngIf="auctionDetail?.saleType?.isDetailPageInHouse">
                <ng-container *ngIf="
                    auctionDetail?.saleType?.registrationFormat ===
                      registrationFormat.tbgRegistration &&
                    auctionDetail?.saleType?.isCatalogUploadAllowed &&
                    auctionDetail?.saleType?.isCatalogReadOnly
                  ">
                  <button mat-menu-item *ngIf="
                      auctionDetail?.auctionStatus != auctionStatuses.past &&
                      auctionDetail?.isRegistrationActive == false
                    " role="button" (click)="auctionStartRegistration(auctionDetail?.id)" type="button">
                    <span>Start Registration</span>
                  </button>
                  <button mat-menu-item *ngIf="
                      auctionDetail?.auctionStatus != auctionStatuses.past &&
                      auctionDetail?.isRegistrationActive == true
                    " role="button" (click)="auctionStopRegistration(auctionDetail?.id)" type="button">
                    <span>Stop Registration</span>
                  </button>
                  <button mat-menu-item role="button" (click)="goToUsers()" *ngIf="
                      auctionDetail?.auctionStatus != auctionStatuses.pending
                    ">
                    <span>View Registered Users</span>
                  </button>
                  <button mat-menu-item *ngIf="
                      auctionDetail?.isEligibleForCommonRegistration &&
                      (auctionDetail?.auctionStatus == auctionStatuses.live ||
                        auctionDetail?.auctionStatus == auctionStatuses.past) &&
                      auctionDetail?.isRegistrationSyncEnabled == false
                    " role="button" (click)="
                      startCommonAuctionRegistration(
                        templateCommon,
                        auctionDetail?.id
                      )
                    " type="button">
                    <span>Start Common Registration</span>
                  </button>
                  <button mat-menu-item *ngIf="
                      (auctionDetail?.auctionStatus == 1 ||
                        auctionDetail?.auctionStatus == 2) &&
                      auctionDetail?.isRegistrationSyncEnabled == true
                    " role="button" (click)="
                      stopSyncRegistrationWithOtherAuction(auctionDetail?.id)
                    " type="button">
                    <span>Stop Common Registration</span>
                  </button>
                  <button mat-menu-item role="button" (click)="goToBidders()" *ngIf="auctionDetail?.auctionStatus == 4">
                    <span>View Bidders</span>
                  </button>
                </ng-container>

                <ng-container *ngIf="auctionDetail?.saleType?.isCatalogUploadAllowed">
                  <button mat-menu-item [routerLink]="['configure-lot']"
                    [queryParams]="{ returnTo: currentUrl, stepActive: 3 }" *ngIf="
                      auctionDetail?.auctionStatus != auctionStatuses.past &&
                      auctionDetail?.saleType.isCatalogUploadAllowed == true
                    ">
                    <span>Manage Lots</span>
                  </button>
                  <a class="no-decoration" [routerLink]="['configure-lot']" [queryParams]="{ returnTo: currentUrl }"
                    mat-menu-item *ngIf="auctionDetail?.auctionStatus != auctionStatuses.past">
                    <span>Configure Lot Catalog</span>
                  </a>
                </ng-container>
              </ng-container>

              <button mat-menu-item *ngIf="
                  auctionDetail?.auctionStatus == 2 &&
                  auctionDetail?.isPublic == false
                " role="button" (click)="markItFeatured(auctionDetail?.id)" type="button">
                <span>Make Featured Auction</span>
              </button>

              <button mat-menu-item *ngIf="
                  auctionDetail?.auctionStatus == 1 ||
                  auctionDetail?.auctionStatus == 2
                " role="button" (click)="markAsSold(auctionDetail?.id)" type="button">
                <span>Mark auction as Sold</span>
              </button>
            </div>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="grey-well">
        <div class="for-badge mb-2">
          <span class="card-badge badge-dark">{{ auctionDetail?.saleType.publicName | isEmpty }}
          </span>
        </div>
        <h1 class="well-name mb-2">
          {{ auctionDetail?.auctionCode | isEmpty }}
        </h1>
        <h3 class="well-des mb-2" [innerHTML]="auctionDetail?.tagline | isEmpty"></h3>
        <ng-container *ngIf="auctionDetail?.saleType?.isDetailPageInHouse">
          <h3 class="well-des">
            Public Link For The Sale :
            <div> <a (click)="openLink(websiteUrl + auctionDetail?.auctionCode)" style="cursor: pointer; color: #8d1231;
            text-decoration: underline;
            cursor: pointer;">Click to view auction detail</a></div>
            <div><a (click)="openLotsLink(websiteUrl + auctionDetail?.auctionCode + '/lots')" style="cursor: pointer; color: #8d1231;
            text-decoration: underline;
            cursor: pointer;">Click to view lot catalog</a></div>
          </h3>


        </ng-container>
      </div>
    </div>
  </div>

  <ng-container *ngIf="auctionDetail?.saleType?.isDetailPageInHouse">
    <div class="row">
      <div class="col-12 mb-3 mb-md-5">
        <div class="list-filter-tabs list-filter-dark pt-4 inline-tab-view">
          <button class="list-tab" [ngClass]="{
              'active-tab': stepActive == 1,
              'completed-tab': stepActive > 1
            }" role="button" (click)="stepActive = 1">
            Basic Details
          </button>
          <button class="list-tab" [ngClass]="{
              'active-tab': stepActive == 2,
              'completed-tab': stepActive > 2
            }" role="button" (click)="stepActive = 2">
            Display Details
          </button>
          <button class="list-tab" [ngClass]="{
              'active-tab': stepActive == 3,
              'completed-tab': stepActive > 3
            }" role="button" (click)="stepActive = 3">
            Locations & Contacts
          </button>
          <button class="list-tab" [ngClass]="{
              'active-tab': stepActive == 4,
              'completed-tab': stepActive > 4
            }" role="button" (click)="stepActive = 4">
            Lot Catalog
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="row">
    <div class="col-12">
      <div class="auction-details-tabs-data" *ngIf="stepActive == 1">
        <div class="edit-auction-tab-data">
          <div class="max-width-720">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Title</h3>
                  <p class="des">{{ auctionDetail?.title | isEmpty }}</p>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">By Order Of</h3>
                  <p class="des">{{ auctionDetail?.byOrderOf | isEmpty }}</p>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Tagline</h3>
                  <p class="des" [innerHTML]="auctionDetail?.tagline | isEmpty"></p>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Auction/Sale Code</h3>
                  <p class="des">{{ auctionDetail?.auctionCode | isEmpty }}</p>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Sale Type</h3>
                  <p class="des">{{ auctionDetail?.saleTypeName | isEmpty }}</p>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Auction Category</h3>
                  <p class="des">{{ auctionDetail?.categoryName | isEmpty }}</p>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Sale Manager</h3>
                  <p class="des">
                    {{ auctionDetail?.saleManagerName | isEmpty }}
                  </p>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Currency</h3>
                  <p class="des">{{ auctionDetail?.currencyName | isEmpty }}</p>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Timezone</h3>
                  <p class="des">{{ auctionDetail?.timeZoneName | isEmpty }}</p>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Start Date & Time</h3>
                  <p class="des">
                    {{
                    auctionDetail?.startDateTime
                    | toLocalDateTime: false:auctionDetail?.timeZoneName
                    }}
                  </p>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">End Date & Time</h3>
                  <p class="des">
                    {{
                    auctionDetail?.endDateTime
                    | toLocalDateTime: false:auctionDetail?.timeZoneName
                    }}
                  </p>
                </div>
              </div>

              <ng-container *ngIf="auctionDetail?.saleType?.isDetailPageInHouse">
                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Stagger Auction Completion Time</h3>
                    <p class="des">
                      {{ auctionDetail?.staggerLotCloseTime | isEmpty }}
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Registrations</h3>
                    <p class="des">
                      {{
                      auctionDetail?.isRegistrationActive
                      ? "Enabled"
                      : "Disabled"
                      }}
                    </p>
                  </div>
                </div>
              </ng-container>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Featured</h3>
                  <p class="des">
                    {{ auctionDetail?.isPublic ? "Yes" : "No" }}
                  </p>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Last Updated</h3>
                  <p class="des">
                    {{ auctionDetail?.updateByName | isEmpty }}
                    <br />
                    {{ auctionDetail?.updateOn | toLocalDateTime }}
                  </p>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Approved By</h3>
                  <p class="des" *ngIf="auctionDetail?.approvedByName; else elseBlock">
                    {{ auctionDetail?.approvedByName }}
                    <br />
                    {{ auctionDetail?.approvedOn | toLocalDateTime }}
                  </p>
                  <ng-template #elseBlock>
                    <p class="des">Pending Approval</p>
                  </ng-template>
                </div>
              </div>

              <ng-container *ngIf="auctionDetail?.saleType?.isDetailPageInHouse">
                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Every Lot Closes In</h3>
                    <p class="des">
                      {{ auctionDetail?.staggerLotCloseTime | isEmpty }}
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Minutes To Extend</h3>
                    <p class="des">
                      {{ auctionDetail?.extendMinutes | isEmpty }}
                    </p>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="!auctionDetail?.saleType?.isDetailPageInHouse">
                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Redirection Link</h3>
                    <p class="des">
                      {{ auctionDetail?.detailPageLinkUrl | isEmpty }}
                    </p>
                  </div>
                </div>
              </ng-container>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Cover Photo</h3>
                  <p class="des d-flex">
                    <img class="thumb-icon2 img-fluid" AuctionDefaultImage *ngIf="auctionDetail"
                      [image]="auctionDetail?.coverPhoto" />
                  </p>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auction-basic-part">
                  <h3 class="hdg">Client Logo</h3>
                  <p class="des d-flex">
                    <img class="thumb-icon2 img-fluid" AuctionDefaultImage *ngIf="auctionDetail"
                      [image]="auctionDetail?.clientLogo" />
                  </p>
                </div>
              </div>

              <ng-container *ngIf="auctionDetail?.saleType?.isDetailPageInHouse">
                <div class="col-12">
                  <div class="auction-basic-part mb-3">
                    <h3 class="hdg mb-2 pb-1">Slider Images</h3>
                    <div class="slider-images">
                      <div class="slide-image-wrap" *ngFor="
                          let item of auctionDetail?.sliderImages;
                          index as i;
                          count as len
                        ">
                        <span *ngIf="len == 0; else elseBlock">-</span>
                        <ng-template #elseBlock>
                          <img [src]="item.name" *ngIf="i < 3" />
                          <div *ngIf="i == 3" class="slide-image-wrap view-more cursor-pointer" role="button"
                            (click)="openModalViewMore(template3)">
                            <img [src]="item.name" />
                            <div class="view-more-text">
                              <span>View More</span>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="auction-basic-part mb-3">
                    <h3 class="hdg mb-2 pb-1">Photo Gallery</h3>
                    <div class="slider-images">
                      <div *ngFor="
                          let item of auctionDetail?.photoGallery;
                          index as i;
                          count as len
                        ">
                        <span *ngIf="len == 0; else elseBlock1">-</span>
                        <ng-template #elseBlock1>
                          <div class="slide-image-wrap" *ngIf="i < 3">
                            <img [src]="item.name" />
                          </div>
                          <div *ngIf="i == 3" class="slide-image-wrap view-more cursor-pointer" role="button"
                            (click)="openModalViewMore(template4)">
                            <img [src]="item.name" />
                            <div class="view-more-text">
                              <span>View More</span>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="auctionDetail?.saleType?.isDetailPageInHouse">
        <div class="auction-details-tabs-data" *ngIf="stepActive == 2">
          <div class="display-tab-data">
            <div class="max-width-720">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Registration Link URL</h3>
                    <p class="des">
                      {{ auctionDetail?.registrationLinkUrl | isEmpty }}
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Catalog Link URL</h3>
                    <p class="des">
                      {{ auctionDetail?.catalogLinkUrl | isEmpty }}
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Page Title</h3>
                    <p class="des">{{ auctionDetail?.pageTitle | isEmpty }}</p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Meta Description</h3>
                    <p class="des">
                      {{ auctionDetail?.metaDescription | isEmpty }}
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Keywords</h3>
                    <p class="tags-outer m-0" *ngFor="
                        let key of auctionDetail?.keywords?.split(',');
                        count as len
                      ">
                      <span *ngIf="len == 0; else elseBlock2">-</span>
                      <ng-template #elseBlock2></ng-template>
                      <span class="tag">{{ key }}</span>
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Related Auctions</h3>
                    <p class="tags-outer m-0" *ngFor="
                        let key of auctionDetail?.relatedAuctionNames?.split(
                          ','
                        );
                        count as len
                      ">
                      <span *ngIf="len == 0; else elseBlock2">-</span>
                      <ng-template #elseBlock2>
                        <span class="tag">{{ key }}</span>
                      </ng-template>
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">
                      Pre Approval Registration Email Template
                    </h3>
                    <p class="des">
                      {{
                      auctionDetail?.preApprovalRegistrationEmailTemplateName
                      | isEmpty
                      }}
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">
                      Post Approval Registration Email Template
                    </h3>
                    <p class="des">
                      {{
                      auctionDetail?.postApprovalRegistrationEmailTemplateName
                      | isEmpty
                      }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Email Notes</h3>
                    <p class="des">{{ auctionDetail?.emailNotes | isEmpty }}</p>
                  </div>

                  <div class="auction-basic-part">
                    <h3 class="hdg pb-2">Documents</h3>
                    <div class="file-preview-outer file-with-hover" *ngFor="
                        let item of auctionDetail?.documents;
                        count as len
                      ">
                      <span *ngIf="len == 0; else elseBlock34">-</span>
                      <ng-template #elseBlock34>
                        <div class="file-preview">
                          <a [href]="item.name">
                            <div class="file-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="28" viewBox="0 0 17 28">
                                <g fill="none" fill-rule="evenodd">
                                  <g fill="#68677B" fill-rule="nonzero" stroke="#FFF" stroke-width=".7">
                                    <path
                                      d="M341.5 1020c-4.14-.004-7.495-3.305-7.5-7.378V999.27c0-2.91 2.398-5.27 5.357-5.27s5.357 2.36 5.357 5.27v11.595c0 1.746-1.439 3.162-3.214 3.162s-3.214-1.416-3.214-3.162v-8.081c0-.582.48-1.054 1.071-1.054.592 0 1.072.472 1.072 1.054v8.08c0 .583.48 1.055 1.071 1.055.592 0 1.071-.472 1.071-1.054V999.27c0-1.746-1.439-3.162-3.214-3.162s-3.214 1.416-3.214 3.162v13.352c0 2.91 2.398 5.27 5.357 5.27s5.357-2.36 5.357-5.27v-14.054c0-.583.48-1.054 1.072-1.054.591 0 1.071.471 1.071 1.054v14.054c-.005 4.073-3.36 7.374-7.5 7.378z"
                                      transform="translate(-333 -993)" />
                                  </g>
                                </g>
                              </svg>
                            </div>
                            <div class="file-dtls">
                              <p class="file-name">
                                {{ item.title | isEmpty }}
                              </p>
                            </div>
                          </a>
                        </div>
                      </ng-template>
                    </div>
                  </div>

                  <div class="auction-basic-part">
                    <h3 class="hdg pb-2">In Conjuction With</h3>
                    <p class="des conjuctation-logo" *ngFor="
                        let item of auctionDetail?.partnerLogos;
                        count as len
                      ">
                      <span *ngIf="len == 0; else elseBlock4">-</span>
                      <ng-template #elseBlock4>
                        <img class="img-fluid" [src]="item.name" />
                      </ng-template>
                    </p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Payment Instructions</h3>
                    <p class="des" [innerHTML]="auctionDetail?.paymentInstructions | isEmpty"></p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Buyer's Premium</h3>
                    <p class="des">
                      {{ auctionDetail?.generalBuyerPremium | isEmpty }}
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Featured Items</h3>
                    <span *ngIf="
                        auctionDetail?.featuredItems == null ||
                          auctionDetail?.featuredItems == '';
                        else elseBlock45
                      ">-</span>
                    <ng-template #elseBlock45>
                      <p class="des" [innerHtml]="auctionDetail?.featuredItems"></p>
                    </ng-template>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="auction-basic-part">
                    <h3 class="hdg">
                      Featured Items Header
                      <span
                        matTooltip='Type or paste the "Featured Items" into this field and review the formatting before posting'
                        [matTooltipPosition]="'above'">
                        <img src="../assets/images/info.svg" />
                      </span>
                    </h3>
                    <p class="des">
                      {{ auctionDetail?.featuredItemHeader | isEmpty }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6" *ngFor="let item of auctionDetail?.customButtons">
                  <div class="auction-basic-part">
                    <h3 class="hdg">Custom Buttons</h3>
                    <div class="btn-display">
                      <div class="display-parts">
                        <h4 class="parts-hdg">Button Logo/Image</h4>
                        <p class="parts-dtl">
                          <a href="{{
                            item.isUrl
                              ? item.url
                              : item.auctionFileName
                          }}" target="_blank">
                            <img [src]="item.buttonName" height="100" />
                          </a>
                        </p>
                      </div>

                      <div class="display-parts">
                        <h4 class="parts-hdg">Button Label</h4>
                        <p class="parts-dtl">{{ item.label }}</p>
                      </div>

                      <div class="display-parts">
                        <h4 class="parts-hdg">Button Type</h4>
                        <p class="parts-dtl" *ngIf="item.isUrl == true">Link</p>
                        <p class="des" *ngIf="item.isUrl == false">Button</p>
                      </div>

                      <div class="display-parts">
                        <h4 class="parts-hdg">URL</h4>
                        <p class="parts-dtl">{{ item.url | isEmpty }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="auctionDetail?.saleType?.isDetailPageInHouse">
        <div class="auction-details-tabs-data" *ngIf="stepActive == 3">
          <div class="location-tab-data">
            <div class="location-hdg">
              <h3 class="hdg">Locations</h3>
            </div>
            <section class="data-table-wrap">
              <div class="empty-auction-location" *ngIf="
                  auctionDetail?.auctionLocations.length <= 0;
                  else showLocations
                ">
                <div class="not-found">
                  <img class="not-found-icon" src="../assets/images/location.svg" />
                  <h3 class="not-added">Location not added</h3>
                </div>
              </div>

              <ng-template #showLocations>
                <table mat-table [dataSource]="auctionDetail?.auctionLocations"
                  class="mat-elevation-z8 border-0 dark-table location-tab-table location-table">
                  <ng-container matColumnDef="locationName">
                    <th class="column-1 listing-header-name" mat-header-cell *matHeaderCellDef>
                      <h3></h3>
                    </th>
                    <td class="column-1 listing-data-entry name table-grey-row" data-column="" mat-cell
                      *matCellDef="let element">
                      <p class="row-name m-0">Location Name</p>
                      <p class="user-val">
                        {{ element.name | isEmpty: "TBD" }}
                      </p>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="address">
                    <th class="column-2 listing-header-name" mat-header-cell *matHeaderCellDef>
                      <h3>Name</h3>
                    </th>
                    <td class="column-2 listing-data-entry yellow-bg name" data-column="Name" mat-cell
                      *matCellDef="let element">
                      <p class="row-name m-0">Address</p>
                      <p class="user-val" [innerHTML]="element.address | isEmpty"></p>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="lot">
                    <th class="column-3 listing-header-name" mat-header-cell *matHeaderCellDef>
                      <h3>Company</h3>
                    </th>
                    <td class="column-3 listing-data-entry name table-grey-row" data-column="Company" mat-cell
                      *matCellDef="let element">
                      <p class="row-name m-0">Lot#</p>
                      <p class="user-val">{{ element.lotNumbers | isEmpty }}</p>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th class="column-4 listing-header-name" mat-header-cell *matHeaderCellDef>
                      <h3>Phone</h3>
                    </th>
                    <td class="column-4 listing-data-entry name" data-column="Phone" mat-cell *matCellDef="let element">
                      <div class="for-icons ml-auto">
                        <a class="hover-icon eye-icon" role="button"
                          (click)="showLocationDetail(element.id, template2)"></a>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
              </ng-template>
            </section>

            <div class="location-hdg mt-4 pt-2">
              <h3 class="hdg">Contacts</h3>
            </div>
            <section class="data-table-wrap">
              <div class="empty-auction-location" *ngIf="
                  auctionDetail?.auctionContacts.length <= 0;
                  else showContacts
                ">
                <div class="not-found border-top-only">
                  <img class="not-found-icon" src="../assets/images/contact.svg" />
                  <h3 class="not-added">Contact not added</h3>
                </div>
              </div>
              <ng-template #showContacts>
                <table mat-table [dataSource]="auctionDetail?.auctionContacts"
                  class="mat-elevation-z8 border-0 dark-table contact-tab-table">
                  <ng-container matColumnDef="locationName">
                    <th class="column-1 listing-header-name" mat-header-cell *matHeaderCellDef>
                      <h3></h3>
                    </th>
                    <td class="column-1 listing-data-entry name table-grey-row" data-column="" mat-cell
                      *matCellDef="let element">
                      <p class="row-name m-0">Contact Name</p>
                      <p class="user-val">
                        {{ element.contactName | isEmpty }}
                      </p>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="address">
                    <th class="column-2 listing-header-name" mat-header-cell *matHeaderCellDef>
                      <h3>Name</h3>
                    </th>
                    <td class="column-2 listing-data-entry yellow-bg name" data-column="Name" mat-cell
                      *matCellDef="let element">
                      <p class="row-name m-0">Designation</p>
                      <p class="user-val">
                        {{ element.description | isEmpty }}
                      </p>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="lot">
                    <th class="column-3 listing-header-name" mat-header-cell *matHeaderCellDef></th>
                    <td class="column-3 listing-data-entry name table-grey-row" data-column="Company" mat-cell
                      *matCellDef="let element">
                      <p class="row-name m-0">Email</p>
                      <p class="user-val">
                        <a href="mailto:{{ element.email }}">
                          {{ element.email | isEmpty }}
                        </a>
                      </p>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th class="column-4 listing-header-name" mat-header-cell *matHeaderCellDef>
                      <h3>Phone</h3>
                    </th>
                    <td class="column-4 listing-data-entry name" data-column="Phone" mat-cell *matCellDef="let element">
                      <p class="row-name m-0">Phone Number</p>
                      <p class="user-val">
                        {{ element.mobileNumber | isEmpty }}
                      </p>
                    </td>
                  </ng-container>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns3"></tr>
                </table>
              </ng-template>
            </section>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="auctionDetail?.saleType?.isDetailPageInHouse">
        <div class="auction-details-tabs-data" *ngIf="stepActive == 4">
          <lot-listing [isAdminViewLot]="true" [auctionId]="auctionId" [auctionData]="auctionDetail"></lot-listing>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #template>
  <div class="modal-header align-items-start">
    <h4 class="modal-title pull-left">View Lot Images</h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="modalRef.hide()">
      <img src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <div class="lot-slider custom-slick-arrow custom-lot">
      <div class="main-slides">
        <div class="image-slides-wrap">
          <ngx-slick-carousel class="carousel image-slides" [config]="imagesSlider">
            <div ngxSlickItem *ngFor="let slide of auctionDetail?.photoGallery" class="slide">
              <img src="{{ slide.name }}" alt="" width="100%" />
            </div>
          </ngx-slick-carousel>
        </div>
      </div>

      <div class="thumbs-outer">
        <ngx-slick-carousel class="carousel thumbs" [config]="thumbnailsSlider">
          <div ngxSlickItem *ngFor="let slide of auctionDetail?.photoGallery" class="slide">
            <img src="{{ slide.name }}" alt="" width="100%" />
          </div>
        </ngx-slick-carousel>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #template2>
  <div *ngIf="location">
    <div class="modal-header">
      <h4 class="modal-title pull-left">View Location</h4>
      <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="modalRef.hide()">
        <img src="../assets/images/cross.svg" />
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="auction-basic-part">
            <h3 class="hdg">Location Name</h3>
            <p class="des">{{ location.name | isEmpty }}</p>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="auction-basic-part">
            <h3 class="hdg">Lot #</h3>
            <p class="des">{{ location.lotNumbers | isEmpty }}</p>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="auction-basic-part">
            <h3 class="hdg">Address</h3>
            <p class="des" [innerHTML]="location.address | isEmpty"></p>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="auction-basic-part">
            <h3 class="hdg">Sales Tax Rate (%)</h3>
            <p class="des">{{ location.salesTaxRate }}</p>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="auction-basic-part">
            <h3 class="hdg">Removal Dates & Rules</h3>
            <p class="des" [innerHtml]="location.removalDateAndRules"></p>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="auction-basic-part">
            <h3 class="hdg">Sales Tax Details</h3>
            <p class="des inner-scroller" [innerHtml]="location.salesTaxDetail"></p>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="auction-basic-part">
            <h3 class="hdg">Inspection Preview</h3>
            <p class="des inner-scroller" [innerHtml]="location.inspectionPreview"></p>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="auction-basic-part">
            <h3 class="hdg">Rigging/Shipping</h3>
            <p class="des inner-scroller" [innerHtml]="location.riggingAndShipping"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #template3>
  <div class="modal-header align-items-start">
    <h4 class="modal-title pull-left">Slider Images</h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="modalRef.hide()">
      <img src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <div class="lot-slider custom-slick-arrow view-more-slider">
      <div class="main-slides">
        <div class="image-slides-wrap">
          <ngx-slick-carousel class="carousel image-slides2" [config]="imagesSlider2">
            <div ngxSlickItem *ngFor="let slide of auctionDetail?.sliderImages" class="slide">
              <img src="{{ slide.name }}" alt="" width="100%" />
            </div>
          </ngx-slick-carousel>
        </div>
      </div>

      <div class="thumbs-outer">
        <ngx-slick-carousel class="carousel thumbs" [config]="thumbnailsSlider2">
          <div ngxSlickItem *ngFor="let slide of auctionDetail?.sliderImages" class="slide">
            <img src="{{ slide.name }}" alt="" width="100%" />
          </div>
        </ngx-slick-carousel>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #template4>
  <div class="modal-header align-items-start">
    <h4 class="modal-title pull-left">Photo Gallery</h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="modalRef.hide()">
      <img src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <div class="lot-slider custom-slick-arrow view-more-slider">
      <div class="main-slides">
        <div class="image-slides-wrap">
          <ngx-slick-carousel class="carousel image-slides2" [config]="imagesSlider2">
            <div ngxSlickItem *ngFor="let slide of auctionDetail?.photoGallery" class="slide">
              <img src="{{ slide.name }}" alt="" width="100%" />
            </div>
          </ngx-slick-carousel>
        </div>
      </div>

      <div class="thumbs-outer">
        <ngx-slick-carousel class="carousel thumbs" [config]="thumbnailsSlider2">
          <div ngxSlickItem *ngFor="let slide of auctionDetail?.photoGallery" class="slide">
            <img src="{{ slide.name }}" alt="" width="100%" />
          </div>
        </ngx-slick-carousel>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #startStopTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="modalRef.hide()">
      <img src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body my-activate">
    <img class="act-icon" src="../assets/images/deactivate_user.svg" />
    <p class="des mb-4"></p>
    <p class="des" *ngIf="auctionDetail?.isRegistrationActive == true">
      Are you sure you want to stop registration for this Auction?
    </p>
    <p class="des" *ngIf="auctionDetail?.isRegistrationActive == false">
      Are you sure you want to start registration for this Auction?
    </p>
    <button *ngIf="auctionDetail?.isRegistrationActive == true" [disabled]="submitLoader" class="btn btn-colored"
      role="button" (click)="auctionStopRegistration(auctionDetail?.id)" type="button">
      <span *ngIf="submitLoader" class="spinner-border spinner-border-sm mr-1"></span>
      Stop
    </button>
    <button *ngIf="auctionDetail?.isRegistrationActive == false" [disabled]="submitLoader" class="btn btn-colored"
      role="button" (click)="auctionStartRegistration(auctionDetail?.id)" type="button">
      <span *ngIf="submitLoader" class="spinner-border spinner-border-sm mr-1"></span>
      Start
    </button>
  </div>
</ng-template>

<ng-template #templateCommon>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Start Common Registration</h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="closeModal()">
      <img src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="approveCommonForm">
      <div class="form-group m-0 pb-1">
        <div class="mat-field-width">
          <div class="custom-select-option select-with-label input-with-tooltip">
            <mat-form-field appearance="outline">
              <mat-label>Select Auction For Common Registration</mat-label>
              <mat-select #selectUpcomingAuction (ngModelChange)="
                  upcomingAuctionChange(selectUpcomingAuction.value)
                " formControlName="syncWithAuctionId" *ngIf="upcomingAuctions != undefined">
                <mat-option value="0" selected>None</mat-option>
                <mat-option *ngFor="let auction of upcomingAuctions" [value]="auction.value">
                  {{ auction.text }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <span class="custom-tooltip" #tooltip="matTooltip" matTooltip="Select an Auction to link to this sale."
              [matTooltipPosition]="'above'">
              <img src="../assets/images/info.svg" />
            </span>
          </div>
        </div>
        <p class="note-text">
          Please note common registration auction once selected cannot be
          changed.
        </p>
      </div>
      <div class="image-popup-wrap pt-4 mt-2">
        <button class="btn btn-white-border mr-2" role="button" (click)="closeModal()">
          Cancel
        </button>
        <button type="submit" class="btn btn-colored" [disabled]="
            submitLoader ||
            approveCommonForm.invalid ||
            disableCommonRegistrationButton
          " role="button" (click)="syncRegistrationWithOtherAuction()">
          <span *ngIf="submitLoader" class="spinner-border spinner-border-sm mr-1"></span>
          Start Common Auction
        </button>
      </div>
    </form>
  </div>
</ng-template>
